export type DataType = {
    [key: string]: string | string[];
}

export enum DataGroup {
    NODE = 'node',
    LINK = 'link'
}

export type NodeType = DataType & {
    id: string;
}

export type LinkType = DataType & {
    source: string;
    target: string;
}

export type SharedDataType = {
    source: string;
    subType: string;
    rangeMin?: number;
    rangeMax?: number;
    rangeField?: string;

    leftGroupKey?: string;
    leftSelectedKey?: string;
    rightGroupKey?: string;
    rightSelectedKey?: string;
}

export type SubTypeColor = { subType: string, color: string, count: number };

export const NODE_SOURCE_LIST_NAME = "sourceList";

export interface Point3D {
    id: string;
    // originalId: string;
    x: number;
    y: number;
    z: number;
    // otherTags: Record<string, string>;
    [k: string]: string | number;
}

export interface DataSet {
    name: string;
    color: string;
    count: number;
}

// Distinct colors for different Protein Families
export const PFAM_COLORS = [
    '#ef4444', // Red
    '#3b82f6', // Blue
    '#22c55e', // Green
    '#eab308', // Yellow
    '#a855f7', // Purple
    '#ec4899', // Pink
    '#06b6d4', // Cyan
    '#f97316', // Orange
];

export const PFAM_NAMES = [
    'PF00001 (7tm_1)',
    'PF00002 (7tm_2)',
    'PF00003 (Cyto_c)',
    'PF00004 (AAA)',
    'PF00005 (ABC_tran)',
    'PF00006 (ATP-synt)',
    'PF00008 (Pkinase)',
    'PF00009 (GTP_EFTU)',
];

export const TOTAL_POINTS = 15000;
export const OTHER_COLOR = '#334155'; // Dark Slate for background points
export const UNKNOWN_COLOR = '#5e5e5e'; // Dark Slate for background points

// 50 Bright, Distinct Colors for Clusters
export const BRIGHT_COLORS = [
    "#1F77B4", "#2CA02C", "#9467BD", "#FF7F0E",
    "#BCBD22", "#8C564B", "#E377C2", "#7F7F7F", // ← remove later if needed
    "#AEC7E8", "#98DF8A", "#C5B0D5", "#FFBB78", "#9EDAE5",
    "#DBDB8D", "#D62728", // ← remove red
    "#393B79", "#637939", "#8C6D31", "#843C39", "#7B4173",
    "#3182BD", "#31A354", "#756BB1", "#FD8D3C",
    "#74C476", "#6BAED6", "#FCCDE5",
    "#80B1D3", "#FDB462", "#8DD3C7", "#FB8072", "#9370DB",
    "#00FA9A", "#FF4500", "#00CED1", "#DA70D6", "#F0E68C",
    "#BEBADA", "#FFFFB3", "#CCEBC5", "#BC80BD",
    "#FFED6F", "#1B9E77", "#D95F02", "#5F9EA0",
    "#7570B3", "#E7298A", "#E6AB02",
    "#A6761D", "#FFB6C1", "#B15928", "#17BECF", "#F0E68C", "#FF1493", "#7CFC00", "#FFD700", "#1E90FF",
];

export const groupKeys: { [k: string]: string[] } = {
    'Pfam': ['anno_pfam', 'pred_pfam'],
    'Gene': ['gene_symbol', 'gene_symbol'],
    'GO-BP': ['anno_go_bp_label', 'pred_go_bp_label'],
    'GO-CC': ['anno_go_cc_label', 'pred_go_cc_label'],
    'GO-MF': ['anno_go_mf_label', 'pred_go_mf_label'],
};
export const groupKeysList = Object.keys(groupKeys);

export const searchGroupTips = {
    'Pfam': 'example: PF00069 → Protein kinase family',
    'Gene': 'example: AKT1 → Cancer signaling gene',
    'GO-BP': 'example: GO:0050911 → Cell signaling',
    'GO-CC': 'example: GO:0005886 → Cell surface signaling',
    'GO-MF': 'example: GO:1990756 → Kinase activity',
}

export type GroupData = { dataCount: { [k: string]: { count: number; color: string; } }; dataList: DataSet[], index: number };
export type GroupDataSet = { [k: string]: GroupData };

export const DataSourceList = [
    { name: 'UniprotKB Annotated', groupIndex: 0 }, // anno_
    { name: '3DisoDeepPF Predicted', groupIndex: 1 }, // pred_
];